import React from "react";
import CCrud from "components/Molecules/Crud";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import FreelancerDetailsPage from "pages/users/drivers/freelancer/freelancerDetails";
import { useTranslation } from "react-i18next";

const FreelancerTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  handleDeleteRequest,
  followers,
  followings,
  cities,
  countries,
}) => {
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const { t } = useTranslation();
  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          // mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          table={{
            list: data,
            listTitle: t("freelancer_drivers.list_title"),
            createBtnTitle: false,
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: t("freelancer_drivers.col_id") },
              {
                accessor: "name",
                Header: t("freelancer_drivers.col_name"),
                sort: true,
              },
              {
                accessor: "phone_number",
                Header: t("freelancer_drivers.col_phone"),
                sort: true,
              },
              {
                accessor: "state",
                Header: t("freelancer_drivers.col_availability"),
              },
              {
                accessor: "approval_status",
                Header: t("freelancer_drivers.col_approval_status"),
              },
              {
                accessor: "list_profile_status",
                Header: t("freelancer_drivers.col_status"),
              },
              {
                accessor: "Actions",
                Header: t("freelancer_drivers.col_actions"),
              },
            ],
            isSearch: false,
            searchInputPlaceholder: t("freelancer_drivers.search_placeholder"),
            isChecked: false,
            total_count: count,
            setFilterObj,
            className: "main-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            actionsList, //if you want to add custom actions list
            headerChildren,
            details,
            openDeleteModal,
            // setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            initialValues: !id ? {} : {},
            structure: () => {},
            validationSchema: {},
            deleteFun: deleteFun,
            title: id
              ? t("freelancer_drivers.edit")
              : t("freelancer_drivers.new"),
            submitTitle: id
              ? t("freelancer_drivers.btn_update")
              : t("freelancer_drivers.btn_add"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          DetailsComponent={
            <FreelancerDetailsPage
              details={details}
              actionsList={actionsList}
            />
          } //to send details component diff from the default
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default FreelancerTemplate;
